export const flattenPropertyUnitList = (data) => {
  let result = []

  data.forEach((item) => {
    result.push(item)

    if (Array.isArray(item.children)) {
      result = result.concat(flattenPropertyUnitList(item.children))
      //   delete item.children
    }
  })

  return result
}

/**
 *
 * @param {{
 *   lease: {
 *    tenantId: string,
 *    bedId: string,
 *   },
 *   tenant: {
 *    firstName: string,
 *    lastName: string,
 *    username: string
 *   },
 *   alias: {
 *    name: string,
 *    contactNumber: string
 *   },
 *   bed: {
 *    bedId: number,
 *    bedName: string
 *   }
 *  }} supplementaryData
 */
// TODO: This doesn't work when renaming a unit  that is vacant -- e.g. no lease exists
export function bedModalPropAdapter(supplementaryData) {
  return {
    lease_details: supplementaryData.lease,
    tenant_details: supplementaryData.tenant,
    leaseId: supplementaryData.lease.leaseId,
    tenantAlias: supplementaryData.alias.name,
    bedId: supplementaryData.bed.bedId,
    bedName: supplementaryData.bed.bedName
  }
}
